<template>
  <Drawer v-bind="{ ...props }" :getContainer="getPopupContainer">
    <slot></slot>
    <template v-for="(slot, name) in $slots" #[name]="slotData">
      <slot v-if="slot" :name="name" v-bind="slotData"></slot>
    </template>
  </Drawer>
</template>

<script lang="ts" setup>
import { Drawer } from 'ant-design-vue';
import { drawerProps } from 'ant-design-vue/es/drawer';

const props = defineProps({
  ...drawerProps(),
  containerId: {
    type: String,
    default: ""
  }
});

const getPopupContainer = function (triggerNode: HTMLElement) {
  const targetContainer = document.getElementById(props.containerId)
  if (targetContainer) {
    console.log("挂在的容器是:" + props.containerId)
    return targetContainer
  } else {
    console.log("挂在的容器是：body")
    return document.body
  }
}

</script>
